import { cn } from '@eliadmin/core/src/utils/style-utils';
import { BlogSkeletonItem } from './blog-skeleton-item';

export const BlogSkeleton = () => {
  return (
    <div
      className={cn(
        'animate-pulse',
        'col-span-1 grid w-full grid-cols-1 gap-6 sm:col-span-2 sm:grid-cols-2 md:gap-8 lg:col-span-3 lg:grid-cols-3',
      )}
    >
      <BlogSkeletonItem firstBlog />
      <BlogSkeletonItem />
      <BlogSkeletonItem />
      <BlogSkeletonItem />
      <BlogSkeletonItem />
    </div>
  );
};
